import { useAuth } from '@/contexts/AuthContext'
import { Link } from 'react-router-dom'
import { ShieldAlert, Home } from 'lucide-react'

export default function ForbiddenPage() {
  const { user } = useAuth()
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-base p-4">
      <div className="text-center max-w-md">
        <ShieldAlert className="w-24 h-24 text-red-500 mx-auto mb-6" />
        <h1 className="text-9xl font-bold text-red-500 mb-4">403</h1>
        <h2 className="text-3xl font-bold text-text-primary mb-4">Access Denied</h2>
        <p className="text-text-secondary mb-8">
          You don't have permission to access this resource.
        </p>
        <Link
          to={user?.authScope === 'client_vault' ? '/client-vault' : '/'}
          className="btn btn-primary"
        >
          <Home className="w-4 h-4 mr-2" />
          Go Home
        </Link>
      </div>
    </div>
  )
}
